import { colorSemaforo, orderingClasificationProject } from "../types/schemesColors";
import { changeMillisecondsToDecimal, getLastDayMonth } from "./changeHours";
import { months, statusProjectSemaforo } from "../types/statusProject";
import { notCountProject } from "../types/initStore/initProject";
import { setFilterDateSunburst } from "./helpersGraph";
import { changeDateTimeZone } from "./dayjsHelper";
import { trimSpaces } from "./textTransform";

const separateAreaSave = (separateNames = [], taskArea = []) => {
    const saves = [];
    separateNames.forEach(({ name }) => {
        saves.push({
            name: name,
            tasks: taskArea[name],
            count: taskArea[name].length,
            subAreas: [
                {
                    name: name,
                    count: taskArea[name].length,
                },
            ],
        });
    });
    return saves;
};

const getGraphTask = (graph = {}) => {
    const separateNames = [{ name: "Vacaciones" }];
    const grapgInternal = [];
    // Iteramos sobre cada key-value
    Object.entries(graph).forEach(([areaName, { taskArea }]) => {

        // Eliminar el prefijo "INMERSYS - " si está presente
        if (areaName.startsWith("INMERSYS - ")) {
            areaName = areaName.replace("INMERSYS - ", "");
        }

        // Creamos un array de objetos subArea, cada uno representando una subárea de tareas en el área actual
        let subAreas = Object.entries(taskArea).map(([subName, tasks]) => {
            const hours = tasks.reduce((total, task) => {
                return total + changeMillisecondsToDecimal(task.time_spent)
            }, 0)
            return ({
                name: subName,
                count: tasks.length,
                hours
            })
        });
        if (areaName === "RH") {
            subAreas = subAreas.filter((sub) => {
                return !separateNames.some((separate) => separate.name === sub.name);
            });

            //* Vacaciones
            const RHSeparate = separateAreaSave(separateNames, taskArea);
            grapgInternal.push(...RHSeparate);
        }
        const { tasks, count, hours } = subAreas.reduce(
            ({ tasks, count, hours }, { name, count: subCount, hours: subHours }) => ({
                tasks: [...tasks, ...taskArea[name]],
                count: count + subCount,
                hours: hours + subHours
            }), { tasks: [], count: 0, hours: 0 }
        );
        grapgInternal.push({ name: areaName, tasks, count, subAreas, hours });
    });
    return grapgInternal;
};


const getPieCharAreas = (graphFormat = [], rgb = [0, 0, 0]) => {
    let pieChart = [];
    let barChart = [];
    let keysBar = [];
    let sectionArea = [];
    if (graphFormat.length === 0) {
        return { pieChart, barChart };
    }
    const { tasks = [] } = graphFormat[0];
    tasks.forEach(({ name, time_spent = 0, list: { name: listName }, folder: { name: folderName } }) => {
        const hoursWork = changeMillisecondsToDecimal(time_spent);
        const findIndex = sectionArea.findIndex((section) => section.folderName === folderName && section.listName === listName);
        if (findIndex > -1) {
            const sumHours = sectionArea[findIndex].hours + hoursWork;
            const value = parseFloat(sumHours.toFixed(2));
            sectionArea[findIndex].hours = value;
        } else {
            sectionArea.push({ folderName, listName, hours: hoursWork });
        }
    });

    sectionArea.forEach(({ folderName, listName, hours }, i) => {
        const rgbColor = generateSimilarColorsFromRGB(rgb, sectionArea.length)[i];
        const existFolder = pieChart.findIndex((pie) => pie.id === folderName);
        if (existFolder > -1) {
            const sumPie = hours + pieChart[existFolder].value;
            const value = parseFloat(sumPie.toFixed(2));
            pieChart[existFolder].value = value;
        } else {
            pieChart.push({ id: folderName, label: folderName, value: hours, color: rgbColor });
        }

        if (trimSpaces(folderName) === trimSpaces("Administración")) {
            const jsonBar = { [listName]: hours, [`${listName}Colors`]: rgbColor };
            keysBar.push(listName);
            if (barChart.length > 0) {
                barChart[0] = { ...barChart[0], ...jsonBar };
            } else {
                barChart.push({ section: "Administración", ...jsonBar });
            }
        }
    });
    return { pieChart, barChart, keysBar };
};

const generateSimilarColorsFromRGB = (baseColorRGB, count) => {
    const [baseR, baseG, baseB] = baseColorRGB;
    const step = 20; // Paso para ajustar la intensidad de color
    const similarColors = [];
    for (let i = 0; i < count; i++) {
        const newR = Math.max(0, Math.min(255, baseR - step * i));
        const newG = Math.max(0, Math.min(255, baseG - step * i));
        const newB = Math.max(0, Math.min(255, baseB - step * i));
        similarColors.push(`rgb(${newR}, ${newG}, ${newB})`);
    }
    return similarColors;
};

export const getGraphAreasState = (graph = {}, rgb = [0, 0, 0]) => {
    const taskInfo = getGraphTask(graph);
    const { pieChart, barChart, keysBar } = getPieCharAreas(taskInfo, rgb);
    return {
        graph: pieChart,
        barGraph: barChart,
        keysBar: keysBar,
    };
};

export const colorLineGraph = (status) => {
    let color = "#ccc";
    let index = -1;
    const colorSelect = colorSemaforo.find((color) => color.name === status);
    if (colorSelect !== undefined) {
        color = colorSelect.color;
        index = colorSelect.index;
    }
    return { color, indexColor: index };
};

const comparateDateSort = (a, b) => {
    if (a.dateStatus.year !== b.dateStatus.year) {
        return a.dateStatus.year - b.dateStatus.year;
    }

    if (a.dateStatus.month !== b.dateStatus.month) {
        return a.dateStatus.month - b.dateStatus.month;
    }
    return 0;
};

export const getGraphSemaforoState = (projects = [], date = new Date()) => {
    const years = [];
    const allProject = [];
    let thisMothSave = false;
    const ultimaDateCheckSaveMonth = 7;

    const newProjects = projects.map((project) => {
        const {
            dateStatus: { day, month, year },
        } = project;
        let monthSelect = false;
        const lastDayMonth = getLastDayMonth(month, year);
        if (day >= 0 && day <= ultimaDateCheckSaveMonth) {
            monthSelect = true;
            if (date.getMonth() === month - 1 && date.getFullYear() === year) {
                thisMothSave = true;
            }
        } else if (day >= ultimaDateCheckSaveMonth && day <= lastDayMonth) {
            if (date.getMonth() + 1 === month && date.getFullYear() === year) {
                thisMothSave = true;
            }
        }
        return {
            ...project,
            dateStatus: { day, month: monthSelect ? month - 1 : month, year },
        };
    });
    newProjects.sort(comparateDateSort);
    newProjects.forEach((project) => {
        const { dateStatus } = project;
        const index = allProject.findIndex((pro) => pro.yearId === dateStatus.year);
        if (index > -1) {
            allProject[index].projectsYear.push(project);
        } else {
            allProject.push({ yearId: dateStatus.year, projectsYear: [project] });
            years.push(dateStatus.year);
        }
    });
    const { newTable, selectTableYear } = filerYearSemaforo(allProject, date.getFullYear());
    const { newTableStatus } = filterStatusProject(selectTableYear);

    return { getTable: newTable, allProject, years, thisMothSave, tableStatus: newTableStatus };
};

export const checkConsumeSemaforo = (consumeNumber = 0) => {
    let colorConsume = "#ccc";
    if (isNaN(consumeNumber)) return colorConsume

    let consume = truncateFloat(consumeNumber);
    if (consume >= 0 && consume < 70) {
        colorConsume = statusProjectSemaforo.green;
    } else if (consume >= 70 && consume < 101) {
        colorConsume = statusProjectSemaforo.yellow;
    } else if (consume >= 101 && consume < 116) {
        colorConsume = statusProjectSemaforo.red;
    } else if (consume >= 116 && consume < 200) {
        colorConsume = statusProjectSemaforo.super_red;
    } else if (consume >= 200) {
        colorConsume = statusProjectSemaforo.purple;
    }

    return colorConsume;
};

export const filerYearSemaforo = (allProject = {}, date = 0) => {
    const newTable = [];
    let selectTableYear = [];
    const find = allProject.find((project) => project.yearId === date);
    if (find !== undefined) {
        const { projectsYear } = find;
        selectTableYear = projectsYear;
        projectsYear.forEach((project) => {
            const { dateStatus, status, totalProjects, projects } = project;
            const { color, indexColor } = colorLineGraph(status);
            let id = `${status}`;
            const index = newTable.findIndex((item) => item.id === id);
            const dataItem = {
                indexMonth: dateStatus.month - 1,
                x: months[dateStatus.month - 1],
                y: totalProjects,
            };

            if (index > -1) {
                newTable[index].data.push(dataItem);
            } else {
                newTable.push({
                    id: id,
                    color,
                    indexColor,
                    data: [dataItem],
                    projectsData: projects,
                });
            }
        });
    }

    return { newTable, selectTableYear };
};

export const filterStatusProject = (projects = [], statusFilter = []) => {
    const newTableStatus = [];
    projects.forEach(({ projects, dateStatus, status, totalProjects, ...rest }) => {
        const dataItem = {
            indexMonth: dateStatus.month - 1,
            x: months[dateStatus.month - 1],
            y: totalProjects,
        };
        let id = `${status}`;
        let count = 0;
        const { color, indexColor } = colorLineGraph(status);
        const indexTableStatus = newTableStatus.findIndex((table) => table.id === id);
        if (statusFilter.length > 0) {
            projects.forEach((proyect) => {
                if (statusFilter.includes(proyect.status)) {
                    count++;
                }
            });
            if (count > 0) {
                dataItem.y = count;
                if (indexTableStatus > -1) {
                    newTableStatus[indexTableStatus].data.push(dataItem);
                } else {
                    newTableStatus.push({
                        id: id,
                        color,
                        indexColor,
                        data: [dataItem],
                    });
                }
            }
        } else {
            if (indexTableStatus > -1) {
                newTableStatus[indexTableStatus].data.push(dataItem);
            } else {
                newTableStatus.push({
                    id: id,
                    color,
                    indexColor,
                    data: [dataItem],
                });
            }
        }
    });
    return { newTableStatus };
};

export const truncateFloat = (value = 0) => parseFloat(value.toFixed(2))

export const getCorrectHourStatus = (percentage = 0) => {
    const percentageRanges = [
        {
            min: 0,
            max: 50,
            label: "progress",
            spanishText: "Enprogreso",
            color: "#1fdb6f",
        },
        {
            min: 50,
            max: 100,
            label: "acceptable",
            spanishText: "Aceptable",
            color: "#fff432",
        },
        {
            min: 100,
            max: 115,
            label: "attention",
            spanishText: "Atención",
            color: "#ff0000",
        },
        {
            min: 115,
            max: 200,
            label: "extended",
            spanishText: "Extendido",
            color: "#d20c0c",
        },
        {
            min: 200,
            max: Infinity,
            label: "overflow",
            spanishText: "Desbordado",
            color: "#5B0754",
        },
    ];

    return percentageRanges.find(({ min, max }) => min <= percentage && percentage < max);
};

export const getMonthName = (numberOfMonth = 1) => {
    const months = {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre",
    };

    return months[numberOfMonth] ? months[numberOfMonth] : "Sin Fecha";
};

const sortByNameWithSinAsignarLast = (a, b) => {
    if (a.name === "Sin asignar") return 1;
    if (b.name === "Sin asignar") return -1;
    return a.name.localeCompare(b.name);
};

const setInitSubCategory = ({ subCategoryCount, name, dayFormatYear, color = "#ccc", nameId = "sin" }) => {
    subCategoryCount.push({ name: name, nameId, dates: [dayFormatYear], color, count: 1 });
};

const setSubCategoryExist = ({ selectSubCategory, dayFormatYear }) => {
    selectSubCategory.count = selectSubCategory.count + 1;
    selectSubCategory.dates.push(dayFormatYear);
};

const setNotCategory = (subCategoryCount, dayFormatYear) => {
    if (subCategoryCount.length > 0) {
        setSubCategoryExist({ selectSubCategory: subCategoryCount[0], dayFormatYear });
    } else {
        setInitSubCategory({ subCategoryCount, name: "N/A", nameId: "Sin asignar", dayFormatYear });
    }
};

const findColorForClasification = ({ colors = [], nameFind = "", nameObject = "" }) => {
    const find = colors.find((color) => trimSpaces(color[nameObject]) === trimSpaces(nameFind));
    if (!find) return {};
    return find;
};

const subCategoriesCount = ({ nameCategory, element, subCategoryCount, datesAll, colorsChild }) => {
    const { name, startDate, nameProject } = element;

    if (notCountProject.includes(nameProject)) return;

    const { dayFormatYear } = changeDateTimeZone(startDate);
    if (!datesAll.includes(dayFormatYear)) {
        datesAll.push(dayFormatYear);
    }

    if (name === undefined) {
        setNotCategory(subCategoryCount, dayFormatYear);
        return;
    }

    //* category exist add count new or sum 1 to category
    name.forEach((n) => {
        const findIndex = subCategoryCount.findIndex((subC) => subC.nameId === n);

        if (findIndex < 0) {
            const findColorByChild = findColorForClasification({
                colors: Object.values(colorsChild),
                nameFind: n,
                nameObject: "name",
            });

            setInitSubCategory({
                subCategoryCount,
                name: `${nameCategory}-${n}`,
                nameId: n,
                color: findColorByChild?.color || "#ccc",
                dayFormatYear,
            });
            return;
        }
        setSubCategoryExist({ selectSubCategory: subCategoryCount[findIndex], dayFormatYear });
    });
};

const getClasificationByProject = (pay, datesAll) => {
    let nameCategory = (pay._id.name ||= "Sin asignar");
    let subCategoryCount = [];

    const findColorByClasification = findColorForClasification({
        colors: orderingClasificationProject,
        nameFind: nameCategory,
        nameObject: "name",
    });

    pay.sub.forEach((element) =>
        subCategoriesCount({ nameCategory, element, subCategoryCount, datesAll, colorsChild: findColorByClasification?.child || "#ccc" })
    );

    subCategoryCount.sort(sortByNameWithSinAsignarLast);

    return {
        name: nameCategory,
        color: findColorByClasification?.color || "#ccc",
        children: subCategoryCount,
    };
};

export const getDataCategories = (payload) => {
    // data by graph
    let data = { name: "categorias", children: [] };
    // all years by projects
    let datesAll = [];

    const childrenByCategory = payload.map((pay) => getClasificationByProject(pay, datesAll)).sort(sortByNameWithSinAsignarLast);

    data.children = childrenByCategory;

    const { dataSunburs } = setFilterDateSunburst(data.children);
    data.children = dataSunburs;

    datesAll.sort((a, b) => b - a);

    return {
        data,
        datesAll,
    };
};


export const getIsDevelopment = () => {
    return window.location.hostname !== "clickupcms.inmersys.xyz"
}